import type { ComponentPropsWithoutRef } from 'react'

export function ArrowsRotate(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.3161 4.25393C9.35164 2.51384 6.34549 2.58363 4.46459 4.46331C3.52821 5.39907 3.04089 6.61239 3.00203 7.83872C2.99329 8.11464 2.76239 8.33123 2.48629 8.32249C2.2102 8.31375 1.99347 8.083 2.00221 7.80709C2.04879 6.33681 2.634 4.87895 3.75725 3.75643C6.03281 1.48236 9.68088 1.41587 12.0367 3.55699V2.55447C12.0367 2.27833 12.2605 2.05447 12.5367 2.05447C12.8128 2.05447 13.0367 2.27833 13.0367 2.55447V4.55393C13.0367 4.94053 12.7233 5.25393 12.3367 5.25393H10.3358C10.0596 5.25393 9.83579 5.03008 9.83579 4.75393C9.83579 4.47779 10.0596 4.25393 10.3358 4.25393H11.3161Z"
        fill="currentColor"
      />
      <path
        d="M14.0037 7.93805C14.001 7.66201 13.7748 7.44046 13.4986 7.44321C13.2224 7.44595 13.0007 7.67195 13.0034 7.94799C13.0163 9.24474 12.5281 10.5438 11.5386 11.5327C9.65765 13.4124 6.6514 13.4822 4.68694 11.742H5.53435C5.81049 11.742 6.03435 11.5181 6.03435 11.242C6.03435 10.9658 5.81049 10.742 5.53435 10.742H3.53345C3.14685 10.742 2.83345 11.0554 2.83345 11.442L2.83345 13.4414C2.83345 13.7176 3.05731 13.9414 3.33345 13.9414C3.60959 13.9414 3.83345 13.7176 3.83345 13.4414L3.83345 12.3144C6.18299 14.5819 9.92708 14.5569 12.2459 12.2396C13.4332 11.0531 14.0192 9.49231 14.0037 7.93805Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function CloudSlashIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.647 2.945a.5.5 0 1 1 .707-.707l1.43 1.431A3.998 3.998 0 0 1 10.464 5H11a4 4 0 0 1 2.35 7.239l.408.409a.5.5 0 0 1-.707.707L2.647 2.944Zm9.983 8.574A3 3 0 0 0 11 6H9.888L9.6 5.5A2.998 2.998 0 0 0 5.51 4.396l7.12 7.124Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="m4.204 5.911-.755-.755A3.983 3.983 0 0 0 3 7v.17A3.001 3.001 0 0 0 4 13h7c.094 0 .187-.003.28-.01l-.99-.99H4a2 2 0 0 1-.667-3.886L4 7.878V7c0-.384.072-.751.204-1.089Z"
      />
    </svg>
  )
}

export function WordCountIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17" {...props}>
      <g fill="#000">
        <path
          fillRule="evenodd"
          d="M1 10.122c0-.276.249-.5.556-.5h12.888c.307 0 .556.224.556.5s-.249.5-.556.5H1.556c-.307 0-.556-.224-.556-.5Zm0 3c0-.276.249-.5.556-.5h8.888c.307 0 .556.224.556.5s-.249.5-.556.5H1.556c-.307 0-.556-.224-.556-.5Z"
          clipRule="evenodd"
        />
        <path d="M3.85 1.702v5.87H2.609V2.88h-.035l-1.344.843v-1.1l1.453-.92H3.85Zm1.395 5.871v-.895l2.09-1.934c.533-.514.82-.835.82-1.302 0-.516-.385-.837-.9-.837-.537 0-.892.344-.89.906H5.189c-.003-1.152.842-1.889 2.075-1.889 1.258 0 2.09.72 2.09 1.737 0 .668-.324 1.218-1.531 2.319l-.857.84v.04H9.43v1.015H5.245Zm7.255.08c-1.29 0-2.208-.714-2.228-1.74h1.25c.023.43.432.717.98.717.568 0 .969-.321.966-.789.003-.473-.413-.805-1.078-.805h-.547v-.912h.547c.565 0 .958-.312.955-.773.003-.442-.333-.746-.834-.746-.508 0-.918.29-.932.737h-1.19c.018-1.015.924-1.72 2.127-1.72 1.216 0 2.027.728 2.024 1.654.003.66-.45 1.124-1.106 1.241v.046c.862.109 1.327.63 1.324 1.362.003 1.003-.94 1.728-2.259 1.728Z" />
      </g>
    </svg>
  )
}
